import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import HighlightedPostsComponent from './component';

const HighlightedPostsFr = () => {
  const { highlightedPosts } = useStaticQuery(graphql`
    query StrapiHighlightedPostsFR {
      highlightedPosts: allWpFrancaisPost(
        filter: {
          status: { eq: "publish" },
        }
      limit: 4
      ) {
        nodes {
          id
          title
          date
          path: uri
          featuredImage {
            node {
              filename
              altText
              gatsbyImage(
                layout: FIXED
                placeholder: BLURRED
                width: 280
                height: 190
              )
            }
          }
        }
      }
    }
  `);
  return (
    <HighlightedPostsComponent highlightedPosts={highlightedPosts.nodes} />
  );
};

export default HighlightedPostsFr;
